import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Comprehensiveionic() {
  return (
    <section className="comprehensive_ionic p-100">
      <Container>
        <div className="compre-box-grey">
          <Row>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="order-2 order-md-1 ps-md-0"
            >
              <StaticImage
                src="../../images/services-usa/ionic-app/comprehensive-ionic.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={693}
                height={797}
              />
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="order-1 order-md-2"
            >
              <h2>
                Get Comprehensive{" "}
                <span>Ionic Mobile App Development Solutions</span> with
                TekRevol
              </h2>
              <div className="padd-para">
                <p>
                  At TekRevol, we are fully invested in creating an all-in-one
                  Ionic Mobile app for our clients. The main motive is to create
                  unique designs that are easily compatible with a wide range of
                  devices. By making use of the Ionic framework, we craft unique
                  and highly optimized fast-performing applications that deliver
                  outstanding user experiences to customers worldwide.
                </p>
                <p>
                  TekRevol is a pioneer in Ionic App Development and we sternly
                  believe in making native apps that meet all the cross-platform
                  requirements.
                </p>
                <p>
                  Our solutions guarantee native capabilities across different
                  platforms, be it iOS or Android or on the website, our apps
                  comprise basic features like push notifications, GPS access,
                  and use of the camera.
                </p>
                <p className="mb-0">
                  When you choose to give TekRevol your Ionic app development
                  services, you will rest easy knowing that we are going to
                  deliver some extraordinary apps that will do much more than
                  just browser-based operations. The apps will fully support
                  both the Android WebView and iOS WebView on all operating
                  systems.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Comprehensiveionic;
